import { Box, ToggleButton, Stack, FormControl, FormLabel, ToggleButtonProps, FormLabelProps } from '@mui/material'
import {
    Call as CallIcon,
    Mail as MailIcon,
    Sms as SmsIcon,
    Voicemail as VoicemailIcon,
    FolderShared as FolderSharedIcon,
    Portrait as PortraitIcon,
} from '@mui/icons-material'

const contactOptions: Record<string, { value: string; label: string; icon: React.ReactNode }> = {
    phone: {
        icon: <CallIcon />,
        label: 'Phone',
        value: 'phone',
    },
    email: {
        icon: <MailIcon />,
        label: 'Email',
        value: 'email',
    },
    text: {
        icon: <SmsIcon />,
        label: 'Text',
        value: 'text',
    },
    inperson: {
        icon: <PortraitIcon />,
        label: 'In-Person',
        value: 'inperson',
    },
    voicemail: {
        icon: <VoicemailIcon />,
        label: 'Voicemail',
        value: 'voicemail',
    },
    share: {
        icon: <FolderSharedIcon />,
        label: 'Share',
        value: 'share',
    },
}

type ContactTypeButtonProps = {
    value: string
    selected?: boolean
    onChange: ToggleButtonProps['onChange']
}
const ContactTypeButton = ({ value, selected, onChange }: ContactTypeButtonProps) => {
    const info = contactOptions[value]
    if (!info) {
        return null
    }
    return (
        <ToggleButton
            color="primary"
            selected={selected}
            value={info.value}
            sx={{
                p: 0.75,
                // aspectRatio: '4/1',
                // minWidth: '100px',
            }}
            onChange={(e) => onChange?.(e, info.value)}
        >
            <Stack sx={{ alignItems: 'center', fontSize: 12, textTransform: 'capitalize' }}>
                {info.icon}
                {info.label}
            </Stack>
        </ToggleButton>
    )
}

type ContactTypeSelectProps = {
    value: string
    required: FormLabelProps['required']
    onChange: ContactTypeButtonProps['onChange']
}

export const ContactTypeSelect = ({ value, required, ...rest }: ContactTypeSelectProps) => {
    return (
        <FormControl sx={{ width: '100%' }}>
            <FormLabel required={required}>Select contact type</FormLabel>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(85px, 1fr))',
                    gridGap: (theme) => theme.spacing(1), // Not auto calculating
                    rowGap: 1,
                }}
            >
                <ContactTypeButton value="phone" selected={value === 'phone'} {...rest} />
                <ContactTypeButton value="email" selected={value === 'email'} {...rest} />
                <ContactTypeButton value="text" selected={value === 'text'} {...rest} />
                <ContactTypeButton value="inperson" selected={value === 'inperson'} {...rest} />
                <ContactTypeButton value="voicemail" selected={value === 'voicemail'} {...rest} />
                <ContactTypeButton value="share" selected={value === 'share'} {...rest} />
            </Box>
        </FormControl>
    )
}
